import {
  Inserter,
  Wrapper,
  SessionRole,
  PartMenu,
  DragAndDropContext,
  RouterToTopOnNav,
  Pointer,
  ExtensionView,
} from "nystem-components";
import "./index.css";

const Index = () => (
  <>
    <ExtensionView type="background">
      <SessionRole userrole="logged-in">
        <Inserter source="/youtubeVideo/extension" />
      </SessionRole>
    </ExtensionView>
    <ExtensionView type="content">
      <Inserter source="/youtubeVideo/content" />
    </ExtensionView>
    <ExtensionView type="popup web">
      <DragAndDropContext>
        <Pointer />
        <RouterToTopOnNav />
        <SessionRole userrole="logged-out">
          <Inserter className="max-w-6xl m-auto p-3 text-gray-500" match="*" source="/adminUser/login" />
        </SessionRole>
        <SessionRole userrole="logged-in">
          <PartMenu />
          <Inserter match="*" source="/adminUser/logndebug" className="max-w-6xl m-auto" />
          <Wrapper renderAs="main" className="bg-black text-primary mt-12">
            <Inserter match="/popup.html" source="/youtubeVideo/incoming" />
            <Inserter match="/" source="/youtubeVideo/swipe" />
            <Inserter match="/youtubeChannel*" className="max-w-6xl m-auto" />
            <Inserter match="/tag*" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeVideo/player" />
            <Inserter match="/youtubeVideo/watchLater" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeVideo/view*" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeVideo/tmp*" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeVideo/list" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeVideo/all" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeVideo/incoming" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeVideo/input/*" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeArchivedVideo/input/*" className="max-w-6xl m-auto" />
            <Inserter match="/youtubeArchivedVideo/all" className="max-w-6xl m-auto" />
          </Wrapper>
        </SessionRole>
      </DragAndDropContext>
    </ExtensionView>
  </>
);
export default Index;
